// export default Clients;
import React from "react";
import "./Clients.css";
import img1 from "./images/img1.png";
import img2 from "./images/img2.png";
import img3 from "./images/img3.png";
import img4 from "./images/img4.png";
import img5 from "./images/img5.png";
import img6 from "./images/img6.png";
import img7 from "./images/img7.png";
import img8 from "./images/img8.png";
import img9 from "./images/img9.png";
import img10 from "./images/img10.png";
import img11 from "./images/balaji.png";
import img12 from "./images/ramjanki.png";
import img13 from "./images/ngpl.png";
import img14 from "./images/agrocean.png";
import img15 from "./images/mandysugars.png";
import img16 from "./images/bssail.png";
import img17 from "./images/gemsugar.png";
import img18 from "./images/ksugar.png";
import img19 from "./images/mcpl.png";
import img20 from "./images/uctoa_red.png";
import img21 from "./images/rsmmhead2.png";

import Marquee from "react-fast-marquee"

const Clients = () => {
  const row2 = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10,img11,img12,img13,img14,img15,img16,img17,img18,img19,img20,img21];

  return (
    <>
      <div id="second" className="client-section">
        <div className="wrapper">
          <p className="Text">Our Esteemed Clients</p>
          <p className="sub-heading">
            Empowering Your Vision, Enriching Our Journey Together
          </p>
          <Marquee 
          speed={180}
          className="marquee-container"
          >
            {row2.map((ele, index)=>(
              <div key={index} className="Image-Group">
                <img src={ele} alt="" className="images" />
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    </>
  );
};

export default Clients;
